import React from 'react';
import {IMAGES_REPO} from '../../../config';
import moment from 'moment';
const format = 'D MMMM';

const ComponentView = (props) => {
  const {isSelected, title, sub_title, body, image, start_date, end_date, is_soon} = props;
  return (
    <div className={isSelected ? 'notice-view notice-view--selected' : 'notice-view'}>
      <div className="notice-view__title">
        <h2>{title}</h2><h3>{sub_title}</h3>
      </div>
      {
        !is_soon ? <span>Date:
          {
            moment(new Date(start_date)).format(format)
          }
          a {
            moment(new Date(end_date)).format(format + ' YYYY')
          }
           </span> : <span>Very soon</span>
      }
      <div className="notice-view__image-container">
        <img src={IMAGES_REPO + '' + image}/>
      </div>
      <div className="notice-view__body" dangerouslySetInnerHTML={{__html: body}}></div>
    </div>
  );
};

export default ComponentView;



// WEBPACK FOOTER //
// ./src/components/ListEntity/Entities/Notice.js